<template>
  <div>
    <the-header-second-row>
      <header-task-list
        v-if="campaign && campaign.tasks"
        :tasks="campaign.tasks"
        :id="campaign.id"
      />
    </the-header-second-row>
    <transition name="fade-transform" mode="out-in">
      <component
        v-if="campaign && task"
        :is="componentName"
        :campaign="campaign"
        :task="task"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import HeaderTaskList from './components/HeaderTaskList.vue';
import Airdrop from './components/Task/Airdrop.vue';
import Bitcointalk from './components/Task/Bitcointalk.vue';
import Facebook from './components/Task/Facebook.vue';
import Instagram from './components/Task/Instagram.vue';
import Linkedin from './components/Task/Linkedin.vue';
import Medium from './components/Task/Medium.vue';
import Creative from './components/Task/Creative.vue';
import Reddit from './components/Task/Reddit.vue';
import Steemit from './components/Task/Steemit.vue';
import Telegram from './components/Task/Telegram.vue';
import Twitter from './components/Task/Twitter.vue';
import Translations from './components/Task/Translations.vue';
import Youtube from './components/Task/Youtube.vue';
import Vk from './components/Task/Vkontakte.vue';

export default {
  components: {
    Airdrop,
    Bitcointalk,
    Facebook,
    Instagram,
    Linkedin,
    Medium,
    Creative,
    Reddit,
    Steemit,
    Telegram,
    Twitter,
    Translations,
    Youtube,
    HeaderTaskList,
    Vk
  },

  data() {
    return {
      campaign: null,
      task: null
    };
  },

  computed: {
    componentName() {
      return this.$route.params.name;
    },
    currentTask() {
      if (!this.campaign) return [];
      return this.campaign.tasks.find(task => {
        return task.title.toLowerCase() === this.componentName.toLowerCase();
      });
    }
  },

  watch: {
    campaign() {
      this.fetchCampaignTask({
        campaignId: this.campaign.id,
        taskId: this.currentTask.id
      })
        .then(task => (this.task = task))
        .catch(e => {
          this.$store.commit('SET_PAGE_FAILURE', e);
        });
    },
    componentName() {
      this.fetchCampaignTask({
        campaignId: this.campaign.id,
        taskId: this.currentTask.id
      })
        .then(task => (this.task = task))
        .catch(e => {
          this.$store.commit('SET_PAGE_FAILURE', e);
        });
    }
  },

  methods: {
    ...mapActions({
      fetchCampaign: 'bounty/fetchCampaign',
      fetchCampaignTask: 'bounty/fetchCampaignTask',
      fetchTaskRewardTypes: 'bounty/fetchTaskRewardTypes'
    })
  },

  created() {
    this.fetchTaskRewardTypes();
    this.fetchCampaign({ id: this.$route.params.id }).then(
      res => (this.campaign = res)
    );
  }
};
</script>
